import type { SxProps, Theme } from "@mui/material/styles";

export function getNodeCardSx(params: {
    isDark: boolean;
    isLoading?: boolean;
    isSelected?: boolean;
    nodeColor: string;
    source?: "cs" | "d365";
    width?: number;
}): SxProps<Theme> {
    const { isDark, isLoading, isSelected, nodeColor, source, width } = params;
    const leftColor = isLoading ? "#9e9e9e" : nodeColor;

    return {
        ...(width !== undefined ? { width } : {}),
        borderLeft: `4px solid ${leftColor}`,
        borderColor: isSelected ? nodeColor : undefined,
        borderWidth: isSelected ? 2 : undefined,
        borderStyle: isSelected ? "solid" : undefined,
        borderLeftWidth: 4,
        borderLeftColor: leftColor,
        transition: "all 0.25s cubic-bezier(0.4, 0, 0.2, 1)",
        background: isDark
            ? "rgba(30, 30, 40, 0.75)"
            : "rgba(255, 255, 255, 0.82)",
        backdropFilter: "blur(12px)",
        WebkitBackdropFilter: "blur(12px)",
        boxShadow: isSelected
            ? `0 4px 24px -2px ${nodeColor}33, 0 0 0 1px ${nodeColor}44`
            : isDark
                ? "0 2px 12px -2px rgba(0,0,0,0.4), 0 0 0 1px rgba(255,255,255,0.06)"
                : "0 2px 12px -2px rgba(0,0,0,0.08), 0 0 0 1px rgba(0,0,0,0.05)",
        ...(source === "d365" && {
            backgroundImage: isDark
                ? `linear-gradient(rgba(165, 180, 252, 0.08), rgba(165, 180, 252, 0.08))`
                : `linear-gradient(rgba(99, 102, 241, 0.06), rgba(99, 102, 241, 0.06))`,
        }),
    };
}
